import axiosInstance from '../../api/axiosInstance';

export const getService = async (payload) => {
    const response = await axiosInstance.get(`/portfolio/portfolio-stock-list?userId=${payload}`,);
    return response.data;
};

export const getSampleService = async (payload) => {
    const response = await axiosInstance.get(`portfolio/sample`,);
    return response.data;
};

export const getMultibaggerListService = async () => {
    const response = await axiosInstance.get(`/portfolio/get-multibaggers`);
    return response.data;
};

export const addPortfolio = async (payload) => {
    const response = await axiosInstance.post(`/portfolio/add-to-portfolio`, payload);
    return response.data;
};

export const updatePortfolio = async (payload) => {
    const response = await axiosInstance.post(`/portfolio/update-to-portfolio`, payload);
    return response.data;
};